import { ICON_TYPE } from '../../../icon/icon.constants';

export const LOGO_ICON = {
  type: ICON_TYPE.SERVICE_ICON,
  name: 'rtlplus_root',
};

export const LOGO_ICON_SCALE = 1.0;

export const BRAND_ICON_WIDTH_RATIO = 2.91;
